import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import Loader from "../../../DefaultStyles/Loader";
import { Textarea } from "../../../Input/Textarea";
import AlertModal from "../../../Modal/AlertModal";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../Users/UserDetail/CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";

interface PartyInviteRegSuccessModalProps extends DefaultModalCommonProps {
  data: {
    partyId: string;
    uid: string;
  };
}

export default function PartyInviteRegSuccessModal({
  closeEvent,
  confirmEvent,
  data,
}: PartyInviteRegSuccessModalProps) {
  const [reason, setReason] = useState("");
  const [regUpdateAskModal, setRegUpdateAskModal] = useState(false);
  const [regUpdateBtnClick, setRegUpdateBtnClick] = useState(false);

  // 등록 완료로 업데이트
  const { response, error, loading } = useApi({
    method: "post",
    url: regUpdateBtnClick ? `party/reg` : undefined,
    data: {
      partyid: +data?.partyId?.split("_")[0] ?? 0,
      uid: +data?.uid?.split("_")[0] ?? 0,
      needreg: 0,
      reason,
    },
  });

  useEffect(() => {
    if (error) {
      if (error.code === 400) {
        toast.error("등록 완료 처리에 실패했습니다.");
      }
    }
  }, [error]);

  useEffect(() => {
    if (response?.status === 200) {
      closeEvent();
      if (confirmEvent) {
        confirmEvent();
      }

      toast.success("등록 완료 처리를 성공했습니다.");
    }
  }, [response]);

  return (
    <DefaultModalLayout
      modalTitle="등록 완료 처리"
      isSmallModal={true}
      closeEvent={() => closeEvent()}
      confirmEvent={() => setRegUpdateAskModal(true)}
      type="input"
      confirmDisabled={reason === ""}
    >
      <DeleteModalLabel>등록 완료 처리 사유</DeleteModalLabel>

      <Textarea
        placeholder="등록 완료 처리 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />

      <>
        {loading && <Loader />}

        {regUpdateAskModal && (
          <AlertModal
            title={`${data?.uid}님을
        ${data?.partyId} 파티에
        등록 완료 처리 하시겠습니까?`}
            confirmEvent={() => {
              setRegUpdateAskModal(false);
              setRegUpdateBtnClick(true);
            }}
            cancelEvent={() => setRegUpdateAskModal(false)}
            btnColor={"mint"}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}
